module.exports = __webpack_public_path__ + "img/photo-0087.c44b2479.jpg";